import { Component, OnInit } from "@angular/core";
import { ModelService } from '../../Services/model.service';
import { FtpServer } from "../../Model/FtpServer";
import { lastValueFrom } from "rxjs";
import { Message } from "../../Model/System/Message";
import { FtpImportJobService } from "../../Services/ftp/ftpImportJob.service";
import { FtpServerService } from "../../Services/ftp/ftpServer.service";
import { FtpImportJobSettings } from "../../Model/recurringJobs/ftp/ftpImportJobSettings";
import { RowInsertedEvent, RowUpdatedEvent, RowRemovedEvent, InitNewRowEvent } from "devextreme/ui/data_grid";

@Component({
    selector: "ftpHeinzeImport",
    templateUrl: "ftpHeinzeImport.component.html",
    standalone: false
})
export class FtpHeinzeImportComponent implements OnInit {

  dataSource: FtpImportJobSettings[] = [];
  ftpServers: FtpServer[] = [];

  constructor(public modelService: ModelService, public ftpImportJobService: FtpImportJobService,
    public ftpServerService: FtpServerService) {
    this.onFtpServerChanged = this.onFtpServerChanged.bind(this);

    this.ftpServerService.getAllServer().subscribe((ftpServer: FtpServer[]) => {
      this.ftpServers = ftpServer;
    });

    ftpServerService.onServerChanged.subscribe(() => this.onFtpServerChanged());
    this.run = this.run.bind(this);
  }

  async ngOnInit(): Promise<void> {
    await this.rebuildDataSource();
  }

  async onInitNewRow(event: InitNewRowEvent<FtpImportJobSettings>) {
    event.data.active = true;
    event.data.isHeinzeImport = true;
  }

  private async rebuildDataSource() {
    this.dataSource = await this.ftpImportJobService.getAllFtpImportJobs().toPromise()
      .then((data: FtpImportJobSettings[]) => {
        return data
          .filter((f: FtpImportJobSettings) => f.isHeinzeImport)
          .map((f: FtpImportJobSettings) => {
            f.time = new Date(f.time);
            return f;
          });
      });
  }

  async onRowInserted(event: RowInsertedEvent<FtpImportJobSettings>) {
    event.data.isHeinzeImport = true;
    await lastValueFrom(this.ftpImportJobService.create(event.data));
    await this.rebuildDataSource();
  }

  async onRowUpdated(event: RowUpdatedEvent<FtpImportJobSettings>) {
    event.data.isHeinzeImport = true;
    if (event.data.active) {
      event.data.timesFailed = 0;
    }
    await lastValueFrom(this.ftpImportJobService.update(event.data));
  }

  async onRowRemoved(event: RowRemovedEvent<FtpImportJobSettings>) {
    await lastValueFrom(this.ftpImportJobService.delete(event.data.id));
    await this.rebuildDataSource();
  }

  isManager(): boolean {
    if (this.modelService.loginService.currentUser.currentClaim == "MANAGER" || this.modelService.loginService.currentUser.currentClaim == "ADMIN")
      return true;
    return false;
  }

  onFtpServerChanged() {
    this.ftpServerService.getAllServer().subscribe((ftpServer: FtpServer[]) => {
      this.ftpServers = ftpServer;
    });
  }

  run(d) {
    if (d.data?.id === undefined || d.data?.id === null) {
      this.modelService.systemService.notify(new Message("Bitte den Job zuerst speichern, bevor er manuell ausgeführt wird."));
      return;
    }
    this.ftpImportJobService.run(d.data.id).subscribe(() => {
      this.modelService.systemService.notify(new Message("Job wurde manuell gestartet, er entfernt sich automatisch, sollte er keine Datei importieren."));
    }, error => {
      let msg = new Message();
      msg.type = "Error";
      msg.message = "Fehler beim manuellen starten";
      this.modelService.systemService.notify(msg);
    });
  }
}
